import {Mapper} from '@s-ui/domain'

export class FromAdAggregationRawDataToAdAggregationListValueObjectMapper extends Mapper {
  constructor({
    adAggregationListValueObjectFactory,
    adAggregationValueObjectFactory,
    fromAdAggregationListRawDataToAdAggregationListValueObjectMapper
  }) {
    super()
    this._adAggregationListValueObjectFactory = adAggregationListValueObjectFactory
    this._adAggregationValueObjectFactory = adAggregationValueObjectFactory
    this._fromAdAggregationListRawDataToAdAggregationListValueObjectMapper =
      fromAdAggregationListRawDataToAdAggregationListValueObjectMapper
  }

  map = ({items: adAggregationRawData}) => {
    const items = adAggregationRawData.map(({key, totalResults}) =>
      this._adAggregationValueObjectFactory({
        id: key,
        totalResults
      })
    )
    return this._adAggregationListValueObjectFactory({items})
  }
}
